import React from 'react'
import './header.css';

export default function Header() {
  return (
    <header className="header">
     <div className="top-bar">
     <span className="contact">أتصل بنا علي: </span>
       <div className="tel">
         <a href="tel:01025440616">01025440616</a>
       </div>
       <span className="separator">/</span>
       <div className="tel">
         <a href="tel:01025440616">01025440616</a>
       </div>
     </div>
      <div className="logo">
        <img src="/logos/logo.png" alt="" />
      </div>
    </header>
  )
}
